<template>
  <a-dialog v-model="show" scrollable max-width="35vw" persistent>
    <v-card>
      <v-banner color="primaryLight1" dark sticky single-line tile>
        <v-toolbar color="primaryLight1" dark>
          <span> {{ $t("task.lblConfirmation") }} </span>
          <v-spacer></v-spacer>
          <CloseIcon @click="close" />
        </v-toolbar>
      </v-banner>
      <v-card-text class="black--text">
        <v-row no-gutters>
          <v-col cols="12" sm="12">
            <span>{{ $t("task.lblTaskStatusConfirmation") }}</span></v-col
          >
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" sm="12">
            <v-text-field
              v-model.trim="txtComment"
              prepend-icon="mdi-comment"
              class="mt-4"
              :label="$t('agenda.lblComment')"
              :rules="rules"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="justify-center">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-on="on"
              v-bind="attrs"
              ref="primaryButton"
              color="primaryDark"
              class="font-weight-bold"
              small
              :disabled="!isCommentValid"
              @click="onOkClick"
            >
              <span>{{ $t("btnOk") }}</span>
            </a-btn>
          </template>
          <span>{{ $t("btnOk") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-on="on"
              v-bind="attrs"
              small
              color="secondary"
              class="font-weight-bold ml-2"
              @click="close"
              ><span>{{ $t("btnLabelCancel") }}</span>
            </a-btn>
          </template>
          <span>{{ $t("btnLabelCancel") }}</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </a-dialog>
</template>

<script>
import ConfirmDialog from "../ConfirmDialog.vue";
export default {
  components: { ConfirmDialog },
  name: "StatusConfirmationDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      txtComment: "",
      rules: [(v) => v.length <= 300 || this.$t("ruleCommentTextMaxLength")],
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    isCommentValid() {
      return String(this.txtComment).length <= 300;
    }
  },
  methods: {
    onOkClick,
    close() {
      this.$emit('input', false);
      this.txtComment = "";
    }
  },
};

function onOkClick() {
  this.$emit("change", this.txtComment);
  this.$emit("input", false);
  this.txtComment = "";
}
</script>

<style>
</style>